import React from 'react';
import { Redirect, Route } from 'react-router';
import { HashRouter as Router, Switch } from 'react-router-dom';
import Login from './views/Login';
import WorkOrderRequests from './views/WorkOrderRequests';
import PurchaseOrderRequests from './views/PurchaseOrderRequests';
import CreateWorkOrderRequest from "./views/WorkOrderRequests/Create";
import CreatePurchaseOrderRequest from "./views/PurchaseOrderRequests/Create";
import SharedWorkOrder from "./views/SharedWorkOrder";
import HTTP404 from "./views/HTTP404";
import { transitions, positions, Provider as AlertProvider } from 'react-alert';
import AlertTemplate from 'components/AlertTemplate';
import qs from 'query-string';
import './App.css'

const options = {
    // you can also just use 'bottom center'
    position: positions.TOP_RIGHT,
    timeout: 5000,
    transition: transitions.FADE
};

const App = () => {
    return (
        <AlertProvider template={AlertTemplate} {...options}>
            <Router>
                <Switch>
                    {/* ---- NEWER DESCRIPTIVE ROUTES ---- */}

                    {/* Login */}
                    <Route path="/:id/login" exact component={Login}/>

                    {/* Work Order routes */}
                    <Route path="/work-orders/:id" exact component={SharedWorkOrder}/>
                    <Route path="/:id/work-orders/create" exact component={CreateWorkOrderRequest}/>
                    <Route path="/:id/work-orders/show/:filter" exact component={WorkOrderRequests}/>

                    {/* Purchase Order routes */}
                    <Route path="/:id/purchase-orders/create" exact component={CreatePurchaseOrderRequest}/>
                    <Route path="/:id/purchase-orders/show/:filter" exact component={PurchaseOrderRequests}/>
                    <Route path="/:id/purchase-orders/show/:filter/:orderID" exact component={PurchaseOrderRequests}/>
                    <Route path="/:id/purchase-orders/show/:filter/:orderID/:tab" component={PurchaseOrderRequests}/>

                    {/* ---- Additional Routes for Redirections ---- */}
                    <Route exact path="/:id/work-orders" component={({ match }) =>
                        <Redirect to={`/${match.params.id}/work-orders/show/all`}/>
                    }/>
                    <Route exact path="/:id/purchase-orders/add" component={({ match }) =>
                        <Redirect to={`/${match.params.id}/purchase-orders/create`}/>
                    }/>
                    <Route exact path="/:id/purchase-orders" component={({ match }) =>
                        <Redirect to={`/${match.params.id}/purchase-orders/show/all`}/>
                    }/>

                    {/* ---- OLD ROUTES FOR BACKWARDS COMPATIBILITY ---- */}
                    <Route exact path="/publicrequest/:id" component={({ match }) =>
                        <Redirect to={`/${match.params.id}/work-orders/create`}/>
                    }/>
                    <Route exact path="/:id/view/:email" render={({ match }) => {
                        // log the user in with the email id and persist it
                        localStorage.setItem("email", match.params.email);
                        return <Redirect to={`/${match.params.id}/work-orders`}/>
                    }}/>


                    <Route exact path="/:id/purchase-orders/:email" render={({ match, location }) => {
                        // log the user in with the email id and persist it
                        const query = qs.parse(location.search);
                        localStorage.setItem("email", match.params.email);
                        if(query.id !== undefined){
                            return <Redirect to={`/${match.params.id}/purchase-orders/show/all/${query.id}`}/>
                        } else {
                            return <Redirect to={`/${match.params.id}/purchase-orders/show/all`}/>
                        }
                    }}/>
                    <Route path="/shared/:id" component={({ match }) =>
                        <Redirect to={`/work-orders/${match.params.id}`}/>
                    }/>

                    <Route exact component={HTTP404}/>
                </Switch>
            </Router>
        </AlertProvider>
    );
};

export default App;
